import {
  useAiSettingsDraftUpdateMutation,
  useAiSettingsVersionActivateMutation,
  useAiSettingsVersionCreateMutation,
  useAiSettingsVersionRenameMutation,
} from 'lib-knowledge-management-common/graphql';

import { aiSettingsQueryNames } from '../utils/aiSettingsQueries';

/**
 * Each change is read back before the mutation resolves. The defaults have no
 * id, so the first save cannot land in the cache by normalisation alone, and
 * creating a version changes what the draft query returns.
 */
const refetchOptions = {
  refetchQueries: aiSettingsQueryNames,
  awaitRefetchQueries: true,
};

export function useUpdateAiSettingsDraft(): ReturnType<
  typeof useAiSettingsDraftUpdateMutation
> {
  return useAiSettingsDraftUpdateMutation(refetchOptions);
}

export function useCreateAiSettingsVersion(): ReturnType<
  typeof useAiSettingsVersionCreateMutation
> {
  return useAiSettingsVersionCreateMutation(refetchOptions);
}

export function useActivateAiSettingsVersion(): ReturnType<
  typeof useAiSettingsVersionActivateMutation
> {
  return useAiSettingsVersionActivateMutation(refetchOptions);
}

export function useRenameAiSettingsVersion(): ReturnType<
  typeof useAiSettingsVersionRenameMutation
> {
  return useAiSettingsVersionRenameMutation(refetchOptions);
}
